import Vue from "vue";
import App from "@/App.vue";
import "@/registerServiceWorker";
import router from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import { imageURL } from "./api/mock";
import moment from "moment";
import "moment/locale/pt-br";

Vue.config.productionTip = false;

Vue.prototype.imageURL = (id: number) => imageURL(id);
Vue.prototype.$moment = moment;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
